import { render } from "./NivvoPublicGantt.vue?vue&type=template&id=15bd6570&scoped=true"
import script from "./NivvoPublicGantt.vue?vue&type=script&lang=js"
export * from "./NivvoPublicGantt.vue?vue&type=script&lang=js"

import "./NivvoPublicGantt.vue?vue&type=style&index=0&id=15bd6570&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bd6570"]])

export default __exports__